import UpdateSiHaDocumentationRequestModelBase from '../_generated/modelBases/update-si-ha-documentation-request-model-base';

export default class UpdateSiHaDocumentationRequestModel extends UpdateSiHaDocumentationRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
